import tr from "./tr-TR";
import en from "./en-US";

const languages = {
    "tr-TR": tr,
    "en-US": en,
};

let currentLang = localStorage.getItem("lang") || "tr-TR";

export const setLang = (lang) => {
    if (languages[lang]) {
        currentLang = lang;
        localStorage.setItem("lang", lang);
    }
};

export const t = (key) => {
    const keys = key.split(".");
    let result = languages[currentLang];

    for (const k of keys) {
        result = result?.[k];
        if (result === undefined) return key;
    }

    return result;
};

// Formatlama yardımcıları:
export const formatNumber = (number) => {
    return new Intl.NumberFormat(currentLang).format(number);
};

export const formatDate = (date) => {
    return new Intl.DateTimeFormat(currentLang).format(new Date(date));
};
